







































































import Vue from 'vue'
import CsvImportReport from '@/types/CsvImportReport.interface'
export default Vue.extend({
    computed: {
        importReport(): CsvImportReport {
            return this.$store.getters.importReport
        }
    },
    methods: {
        contactsDuplicatesHelp(): void {
            this.$store.dispatch('dialogOpen', {
                type: 'MESSAGE',
                title: 'Duplicate Contacts',
                text: "We found more than one contact for each of these CSV rows. Use the 'Merge Contacts' feature in 'Settings' to merge your duplicate contacts."
            })
        },
        contactsNotFoundHelp(): void {
            this.$store.dispatch('dialogOpen', {
                type: 'MESSAGE',
                title: 'Contacts Not Found',
                text: 'We could not find a contact for each of these CSV rows. Contact creation when connected to external accounting software must be done manually. Once the contacts are created, you may use the CSV feature to update their information.'
            })
        },
        contactsUpdatedHelp(): void {
            this.$store.dispatch('dialogOpen', {
                type: 'MESSAGE',
                title: 'Contacts Updated',
                text: 'This is a count of all contacts that MessageDesk successfully updated with new data from your CSV file.'
            })
        },
        contactsNotUpdatedHelp(): void {
            this.$store.dispatch('dialogOpen', {
                type: 'MESSAGE',
                title: 'Contacts Not Updated',
                text: `These contacts were found but not updated because the contact overwrite option was disabled. If you would like to update contacts that already exist, check the 'Update existing contacts' box in step 4 of the import process.\nIf this doesn't resolve your issue, please read our <a href="${this.csvFailureLink()}" target="_blank">CSV Troubleshooting Guide</a>.`
            })
        },
        csvFailureLink(): string {
            //  Assemble the support link
            return `${process.env.VUE_APP_URL_LEARN}/en/articles/4547566-troubleshooting-your-csv-when-importing-contacts`
        },
        downloadCreated(): void {
            const url = this.importReport.created.file.tempUrl
            this.$store.dispatch('csvDownload', url)
        },
        downloadDuplicates(): void {
            const url = this.importReport.duplicates.file.tempUrl
            this.$store.dispatch('csvDownload', url)
        },
        downloadNotUpdated(): void {
            const url = this.importReport.not_updated.file.tempUrl
            this.$store.dispatch('csvDownload', url)
        },
        downloadNotFound(): void {
            const url = this.importReport.not_found.file.tempUrl
            this.$store.dispatch('csvDownload', url)
        },
        downloadUpdated(): void {
            const url = this.importReport.updated.file.tempUrl
            this.$store.dispatch('csvDownload', url)
        }
    }
})
